import axios from "axios";
let baseURL
const service = axios.create({
	baseURL: "http://zyz.csapa.ltd",
	// http://zyz.csapa.3ltd
	header: {
		// "Content-Type": "Access-Control-Allow-Origin",
		"Content-Type": "multipart/form-data",
		// "Content-Type": "application/json;charset=UTF-8"
	},
	timeout: 15000, // request timeout
	dataType: "json"
});
// 设置请求拦截器
service.interceptors.request.use(
	config => {
		// console.log('接口请求参数===',config);
		// console.log('接口请求参数===',config.data);
		if (config.data) {
			let data = new FormData()
			for (let i in config.data) {
				data.append(i, config.data[i])
			}
			config.data = data;
		}

		return config;
	},
	error => {
		return Promise.reject(error);
	}
);
// 设置响应拦截器
service.interceptors.response.use(
	response => {
		// console.log('request',response)

		const res = response;
		if (res.data.code !== 20000) {
			if (res.data.code == 200) {
				// 这里抛出的是res.data直接把code这一层拦截了
				return res.data;
			} else if (res.data.code !== 200) {
				// console.log(res.data);
				return res.data;
			}
		} else {
			// console.log(res.data.message);
			return res;
		}
	},
	error => {
		// console.log("err" + error); // for debug
		// vm.$message({
		//         message:'与服务器断开链接',
		//         type: 'error',
		//         duration: 800
		// });
		// 判断是否有返回值

		// Message({
		//   message: error.message,
		//   type: 'error',
		//   duration: 5 * 1000
		// })
		return Promise.reject(error);
	}
);
export default service;
